import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageCode',
  standalone: true,
  pure: true
})
export class LanguageCodePipe implements PipeTransform {
  transform(value: string): string {
    return value.split('-')[0].toUpperCase();
  }
}
